export const SENDGRID_OVERRIDES = {
  featureFlag: true,
};
